module.exports = __webpack_public_path__ + "static/media/electro_white.f41ecc79.svg";